import * as React from "react";
import { Button } from "../Button/Button";
import { AttachmentRow } from "./AttachmentRow";

import { IAttachment } from "../../../classes/attachment";
import { IText_EventViews } from "../../../classes/text";

import FileSaver from "file-saver";
import JSZip from "jszip";

export interface IAttachmentListProps {
    attachments: IAttachment[];
    eventId: number;
    eventViewText: IText_EventViews;
}

export const AttachmentList = (props: IAttachmentListProps) => {
    const onDownloadAll = (e) => {
        e.preventDefault();

        // set up JSZip for create a zip folder
        const zip: JSZip = new JSZip();
        let iteration = 1;
        $("body").css("cursor", "progress");

        // go through each attachment
        for (const attach of props.attachments) {
            // need to get the request/response for each attachment to get its blob
            const xhr = new XMLHttpRequest();
            const fileName = attach.fileName;
            const fileUrl = attach.fileUrl;

            // when the file has been loaded
            xhr.onload = () => {
                // grab the response as a blob
                const blobData = xhr.response;

                // if we can't find it, ignore it
                if (blobData !== null) {
                    // add the blob and it's file name to the zip folder
                    zip.file(fileName, blobData);
                    // when we're at the last file, generate the zip file and download it
                    if (iteration === props.attachments.length) {
                        zip.generateAsync({type: "blob"}).then((blob) => {
                            FileSaver.saveAs(blob, "Attachment.zip");
                            $("body").css("cursor", "default");
                        });
                    }
                } else {
                    alert("something's wrong");
                }
                iteration++;
            };
            // fetch the file from it's location
            xhr.open("GET", fileUrl, true);
            // ensure the response is a blob
            xhr.responseType = "blob";
            xhr.send();
        }
    };

    return (
        <div className="CAL-EVENT-cR-content">
            <ul className="CAL-EVENT-cR-list">
                {props.attachments.map((attachment) =>
                    <AttachmentRow key={attachment.fileId} fileName={attachment.fileName} fileUrl={attachment.fileUrl} fileType={attachment.fileType} />,
                )}
            </ul>
            <div className="link_item"> 
                <span><a className="CMS_pickButton" href="#" onClick={onDownloadAll} download><em className="fa fa-download"></em> {props.eventViewText.downloadAll}</a></span>
            </div>
        </div>
    );
};
